export default {
    url: '/material/content?path',
    template: `
        <courses-authoring-tool-iframe-pdf-viewer ng-if="vm.isPdf" file-path="vm.filePath"/>
        <courses-authoring-tool-iframe-converted-file-viewer ng-if="!vm.isPdf" file-path="vm.filePath"/>
        <style>
        .frame-wrapper {
            padding:0px!important;
        }
        </style>
    `,
    controller ($stateParams, MaterialFileTypeService) {
        this.filePath = $stateParams.path;
        this.isPdf = MaterialFileTypeService.isPdf(this.filePath);
    }
};



// WEBPACK FOOTER //
// ./src/app/states/material/content/index.js